module.exports = __webpack_public_path__ + "static/media/herramienta-rojo.15dbfc45.svg";